<template>
  <FilterMultiChip
    is-text
    :label-mode="labelMode"
    icon="users"
    :label="$t('search-filters.assignees')"
    :items="items"
    :value="value || []"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FilterMultiChip from '@/components/filters/FilterMultiChip';
import { LABEL_MODE } from '@/components/filters/label-mode';

/**
 * Assignees dimension chip. Presentational: `:value` (array of user ids) + `:users` (the roster
 * the page owns) in, `change` out. Multi-select, sorted by name.
 */
export default {
  name: 'AssigneesChip',
  components: { FilterMultiChip },
  props: {
    value: { type: Array, default: () => [] },
    users: { type: Array, default: () => [] },
    // Show the dimension name on the chip face (used in the compact stacked filters dialog).
    isText: { type: Boolean, default: false },
  },
  computed: {
    labelMode: () => LABEL_MODE.COLLAPSE,
    // Two users with the same name are told apart by their email.
    items() {
      const users = this.users || [];
      const nameCount = users.reduce(
        (count, user) => count.set(user.fullName, (count.get(user.fullName) || 0) + 1),
        new Map(),
      );
      return users
        .slice()
        .sort((a, b) => a.fullName.localeCompare(b.fullName))
        .map((user) => ({
          value: user.id,
          text: nameCount.get(user.fullName) > 1 && user.email ? `${user.fullName} (${user.email})` : user.fullName,
        }));
    },
  },
};
</script>
